import Spinner from './Spinner'


const ChartPlaceholder = ({
  height,
  isLoading = false,
  loadingLabel,
  error = null,
  onRetry,
  emptyMessage = 'No data in this time range',
}) => (
  <div className="flex flex-col items-center justify-center gap-2 w-full text-center" style={{ height }}>
    {isLoading ? (
      <Spinner label={loadingLabel} />
    ) : error ? (
      <>
        <span className="material-icons text-2xl text-[#d92d20]">error_outline</span>
        <span className="text-sm font-medium text-[#272d37]">{error}</span>
        {onRetry && (
          <button
            className="mt-1 h-8 px-3 border border-[#dfe4ed] rounded-md bg-white cursor-pointer text-sm text-[#272d37]"
            onClick={onRetry}
          >
            Retry
          </button>
        )}
      </>
    ) : (
      <>
        <span className="material-icons text-2xl text-[#c8cfdc]">show_chart</span>
        <span className="text-sm font-normal text-[#616a79]">{emptyMessage}</span>
      </>
    )}
  </div>
)

export default ChartPlaceholder
